<template>
  <div class="forgot-password">
    <div class="row">
      <div class="col-lg-6 col-lg-offset-3">
        <div class="box">
          <div class="box-body">
            <h2>Forgot password?</h2>
              <br/><br/>
            <p>Please enter your email address below and we will send you instructions on how to reset your password.
            </p>
            <p>
              Email: <br/>
              <input type="text" v-model="emailRecip"/><button @click="sendEmail()" class="btn btn-info btn-xs">Send</button>
              <br/>
              <div v-if="emailError" class="form-section-danger">
                <p>{{ emailError }}</p>
              </div>
              <div v-if="emailSuccess" class="form-section-success">
                <p>{{ emailSuccess }}</p>
              </div>
            </p>
            <br/>
            <p><a v-link="{path:'/'}" class="btn btn-default btn-sm"><span class="fa fa-arrow-left"></span> Back to Login</a></p>
            <hr/>
            <p>If you have any questions, just give us a call at
              <a href="tel:1300575878">1300 575 878</a> or you can email
              <a href="mailto:info@greensharecar.com.au" class="email">
                info@greensharecar.com.au</a>. We're always happy to help!</p>
            <p><img v-bind:src="'https://techcar-dev.s3.amazonaws.com/'+ ( $root.companyLogo ? $root.companyLogo : 'spacer.gif' ) + '?v=' + new Date().getTime()" v-bind:alt="companyName" /><br/> </p></center>
          </div>
        </div>
      </div>
    </div>
    <!-- Error Modal -->
    <error-modal v-if="errorModalActive" v-bind:error-message="errorMessage"></error-modal>
    <!-- Multiple Accounts Modal -->
    <modal v-if="multipleAccountsModalActive" v-el:multiple-accounts-modal>
      <template slot="header">
        Multiple Accounts Found
      </template>
      <template slot="body">
        <p>Multiple accounts were found associated with the email address {{ emailRecip }}. Please enter the username of the account you wish to reset.</p>
        <p>Username: <br/>
        <input type="text" v-model="username"/></p>
        <p>If you can't remember your username please contact us on 1300 575 878</p>
      </template>
      <template slot="footer">
        <button type="button" class="btn btn-info pull-left" data-dismiss="modal">Cancel</button>
        <button class="btn btn-default" @click="sendEmail()" data-dismiss="modal">Send</button>
      </template>
    </modal>
  </div>
</template>

<script>
import ErrorModal from './modals/ErrorModal.vue'
import Modal from './Modal'

export default {
  name: 'ForgotPassword',
  components: {
    Modal,
    ErrorModal
  },
  data () {
    return {
      emailRecip: '',
      emailRegex: /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/,
      emailError: false,
      errorModalActive: false,
      errorMessage: '',
      emailSuccess: false,
      accounts: [],
      multipleAccountsModalActive: false,
      username: ''
    }
  },
  ready () {
  },
  route: {
    data () {
    }
  },
  methods: {
    sendEmail () {
      this.emailError = false
      this.emailSuccess = false
      if (new RegExp(this.emailRegex, 'gi').test(this.emailRecip)) {
        this.$http.post('public/forgot-password', { email: this.emailRecip, username: this.username }).then((response, status, request) => {
          if (response.data === 'sent') {
            this.emailSuccess = `An email has been sent to ${this.emailRecip}.
            You should recieve instructions on resetting your password shortly,
            if you do not receive an email please try again or contact us.
            Remember to check your junk or spam email boxes.`
          } else if (response.data.error) {
            $(this.$els.multipleAccountsModal).modal('hide')
            this.errorModal(response.data.error)
          } else {
            this.accounts = response.data
            this.multipleAccountsModalActive = true
            this.$nextTick(function () {
              $(this.$els.multipleAccountsModal).modal()
              $(this.$els.multipleAccountsModal).on('hidden.bs.modal', () => {
                this.username = ''
                this.multipleAccountsModalActive = false
              })
            })
          }
        })
      } else {
        this.emailError = 'Please enter a valid email.'
      }
    },
    errorModal (error) {
      this.errorMessage = error
      this.errorModalActive = true
      this.$nextTick(function () {
        $('#errorModal').modal()
        $('#errorModal').on('hidden.bs.modal', () => {
          this.errorModalActive = false
        })
      })
    }
  }
}
  </script>



// WEBPACK FOOTER //
// ForgotPassword.vue?1aecdcb5